import { useState } from 'react';

import { Avatar, Popover, Tooltip } from '@mantine/core';

import dayjs from 'dayjs';

import { ReactComponent as MenuDots } from 'assets/icons/menudots.svg';
// import { ReactComponent as LockIcon } from 'assets/icons/lockIcongreen.svg';
import { ReactComponent as CalanderIcon } from 'assets/icons/calanderIcon.svg';
import { ReactComponent as TeamIcon } from 'assets/icons/teamIcon.svg';
// import { ReactComponent as FolderIcon } from 'assets/icons/folderIcon.svg';
import { ReactComponent as PinIcon } from 'assets/icons/pinIcon.svg';

import useUpdateFolder from '../../hooks/useUpdateFolder';
import DeleteFolder from './DeleteFolderModal';
import AddNewFolderModal from './addnewfolderModal';
import { Link } from 'react-router-dom';

const FolderCard = ({ folder }) => {
  const [menuPopover, setMenuPopover] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const [teamMemberPopoverOpened, setTeamMemberPopoverOpened] = useState(false);

  const closePopover = () => {
    setMenuPopover(false);
  };

  const updateFolderMutation = useUpdateFolder(closePopover);
  return (
    <>
      <div className='  rounded-3xl shadow-three p-5'>
        <div className=' flex justify-between items-center '>
          {folder?.name.length >= 35 ? (
            <Tooltip
              label={folder?.name}
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
            >
              <Link
                to={`/app/repository/${folder?.id}`}
                state={{ path: folder?.path }}
              >
                <h1 className='font-semibold text-[#333333] cursor-pointer truncate w-72'>
                  {folder?.name}
                </h1>
              </Link>
            </Tooltip>
          ) : (
            <Link
              to={`/app/repository/${folder?.id}`}
              state={{ path: folder?.path, mainpath: folder?.path }}
            >
              <h1 className='font-semibold text-[#333333] cursor-pointer'>
                {folder?.name}
              </h1>
            </Link>
          )}
          <div className='flex items-center gap-3'>
            {/* <LockIcon /> */}
            {folder?.is_pinned && <PinIcon />}
            <Popover
              opened={menuPopover}
              onClose={() => setMenuPopover(false)}
              target={
                <MenuDots
                  className='h-5 w-5 cursor-pointer'
                  onClick={() => setMenuPopover((o) => !o)}
                />
              }
              width={150}
              position='left'
              classNames={{ body: 'rounded-lg' }}
            >
              <div className='flex flex-col '>
                <p
                  className='cursor-pointer text-sm p-2 text-gray hover:bg-[#fff4ed]'
                  onClick={() => {
                    setNewFolderModal(true);
                    setMenuPopover(false);
                    setFolderId(folder?.id);
                  }}
                >
                  Edit{' '}
                </p>
                <p
                  className='cursor-pointer text-sm p-2 text-gray hover:bg-[#fff4ed]'
                  onClick={() => {
                    setOpenModal(true);
                    setMenuPopover(false);
                  }}
                >
                  Delete{' '}
                </p>
                <p
                  className='cursor-pointer text-sm p-2 text-gray hover:bg-[#fff4ed]'
                  onClick={() => {
                    updateFolderMutation.mutate({
                      id: folder?.id,
                      is_pinned: !folder?.is_pinned,
                    });
                  }}
                >
                  {folder?.is_pinned ? 'Unpin' : 'Pin to top'}
                </p>
              </div>
            </Popover>
          </div>
        </div>

        <div className='flex justify-between items-center'>
          <div className='py-8'>
            <p className='flex items-center gap-2 text-sm py-1 text-[#828282]'>
              <CalanderIcon />
              {dayjs(folder?.created_date).format('DD MMM YYYY, H:m')}
            </p>
            <p className='flex items-center gap-2 text-sm py-1 text-[#828282]'>
              <TeamIcon />{' '}
              {folder?.members.length === 1
                ? `${folder?.members.length} member`
                : `${folder?.members.length} members`}{' '}
            </p>
          </div>

          <div
            className='flex relative'
            // onClick={() => {
            //   // setSelectedRow(element);
            //   setTeamMemberPopoverOpened(true);
            // }}
            onMouseEnter={()=>{
              setTeamMemberPopoverOpened(true);
            }}
            onMouseLeave={()=>{
              setTeamMemberPopoverOpened(false);
            }}
          >
            {folder?.members?.length === 0 ? null : (
              <Avatar
                src={folder?.members[0]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 border-2 border-primary border-opacity-50'
              >
                {folder?.members[0]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            )}
            {folder?.members?.length > 1 ? (
              <Avatar
                src={folder?.members[1]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 transform -translate-x-4 border-2 border-primary border-opacity-50'
              >
                {folder?.members[1]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            ) : null}
            {folder?.members?.length > 2 ? (
              <Avatar
                src={folder?.members[2]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 transform -translate-x-8 border-2 border-primary border-opacity-50'
              >
                {folder?.members[2]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            ) : null}
            {folder?.members?.length > 3 ? (
              <span
                className='w-12 h-12 flex justify-center items-center rounded-full bg-primary transform -translate-x-12 text-white select-none border-2 border-primary border-opacity-50'
                onClick={() => {
                  // setSelectedRow(element);
                  setTeamMemberPopoverOpened(true);
                }}
              >
                +{folder?.members?.length - 3}
              </span>
            ) : null}
          </div>
          <Popover
            opened={teamMemberPopoverOpened}
            onClose={() => setTeamMemberPopoverOpened(false)}
            onMouseEnter={()=>{
              setTeamMemberPopoverOpened(true);
            }}
            onMouseLeave={()=>{
              setTeamMemberPopoverOpened(false);
            }}
            width={200}
            title='Team Members'
            position='left-start'
            placement='center'
            radius='sm'
            classNames={{
              inner: 'py-2 max-h-48 overflow-y-scroll scroller',
              header: 'border-b-0 text-accent font-medium',
              body: 'shadow-four',
            }}
            className='z-0'
          >
            {folder?.members?.map((member) => {
              return (
                <div className='flex space-x-2 pb-4'>
                  <Avatar
                    src={member?.employee__profile_picture}
                    color='#EEF3F1'
                    radius='xl'
                    classNames={{
                      placeholder: 'text-xl',
                    }}
                    className='w-10 h-10'
                  >
                    {member?.employee__user__first_name?.substring(0, 1)}
                  </Avatar>
                  <div className='text-xs mt-1'>
                    <p className='text-121212 truncate w-30'>
                      {member?.employee__user__first_name}
                    </p>
                    <p className='text-868686'>
                      {member?.employee__designation__name}
                    </p>
                  </div>
                </div>
              );
            })}
          </Popover>
        </div>

        <div className='flex justify-between items-center'>
          <div className='flex gap-3'>
            <Avatar
              className='w-12 h-12 border-2 border-primary border-opacity-50'
              radius='xl'
              color='#FB7C51'
              src={folder?.created_by__user_employee__profile_picture}
              classNames={{
                placeholder: 'text-xl',
              }}
            >
              {folder?.created_by__first_name?.substring(0, 1)}
            </Avatar>
            <div className=''>
              <h1 className='text-[#707070]'>
                {folder?.created_by__first_name}
              </h1>
              <p className='text-[#969696] text-sm'>
                {folder?.created_by__user_employee__designation__name ||
                  'Admin'}
              </p>
            </div>
          </div>
          {/* <p className='flex gap-2 items-center text-[#969696]'>
            <FolderIcon /> 05(static)
          </p> */}
        </div>
      </div>
      <DeleteFolder
        openModal={openModal}
        setOpenModal={setOpenModal}
        folderId={folder?.id}
      />
      <AddNewFolderModal
        newFolderModal={newFolderModal}
        setNewFolderModal={setNewFolderModal}
        folderId={folderId}
        setFolderId={setFolderId}
      />
    </>
  );
};

export default FolderCard;
